
import React from "react";
import { TrackingField } from "./TrackingField";
import { TrackingToggle } from "./TrackingToggle";

interface MetaPixelSectionProps {
  metaPixelId: string;
  setMetaPixelId: (value: string) => void;
  metaAccessToken: string;
  setMetaAccessToken: (value: string) => void;
  isEditing: boolean;
  isPixelEnabled?: boolean;
  setIsPixelEnabled?: (value: boolean) => void;
  isApiEnabled?: boolean;
  setIsApiEnabled?: (value: boolean) => void;
}

export const MetaPixelSection: React.FC<MetaPixelSectionProps> = ({
  metaPixelId,
  setMetaPixelId,
  metaAccessToken,
  setMetaAccessToken,
  isEditing,
  isPixelEnabled = true,
  setIsPixelEnabled = () => {},
  isApiEnabled = true,
  setIsApiEnabled = () => {},
}) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-medium">Meta (Facebook) Pixel</h3>
        
        {isEditing && (
          <div className="flex items-center space-x-4">
            <TrackingToggle
              id="meta-pixel-enabled"
              label="Activer le pixel"
              checked={isPixelEnabled}
              onChange={setIsPixelEnabled}
            />
            <TrackingToggle
              id="meta-api-enabled"
              label="Activer l'API"
              checked={isApiEnabled}
              onChange={setIsApiEnabled}
              disabled={!isPixelEnabled}
            />
          </div>
        )}
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <TrackingField
          id="meta-pixel-id"
          label="Pixel ID"
          value={metaPixelId}
          onChange={setMetaPixelId}
          isEditing={isEditing}
          placeholder="Exemple: 123456789012345"
          disabled={!isPixelEnabled && isEditing}
        />
        <TrackingField
          id="meta-access-token"
          label="Access Token"
          value={metaAccessToken}
          onChange={setMetaAccessToken}
          isEditing={isEditing}
          isPassword={true}
          placeholder="Votre token d'accès Meta"
          disabled={(!isPixelEnabled || !isApiEnabled) && isEditing}
        />
      </div>
    </div>
  );
};
